export { KvkkSayfasi } from "./components/kvkk-sayfasi"
export { SozlesmeSayfasi } from "./components/sozlesme-sayfasi"
export { YasalBelgeDialog } from "./components/yasal-belge-dialog"
export {
  KVKK_AYDINLATMA_METNI,
  KVKK_AYDINLATMA_VERSIYON,
  TICARI_ILETI_ONAY_METNI,
} from "./data/kvkk-aydinlatma"
export { KULLANIM_KOSULLARI, KULLANIM_KOSULLARI_VERSIYON } from "./data/kullanim-kosullari"
export { SIRKET_BILGILERI } from "./data/sirket-bilgileri"
export type { YasalBelge } from "./types"
